export default __webpack_public_path__ + "static/media/sticker-17.87b4c1d2.png";